module.exports = __webpack_public_path__ + "media/images/sale_crm/leads-946aacab7b9bfe48e35322e0cdbeea5a.svg";